import { useEffect, useState } from 'react';
import { Swords } from 'lucide-react';
import { api } from '../lib/api';

export default function Ticker() {
  const [names, setNames] = useState([]);

  useEffect(() => {
    const load = () => {
      api
        .tournaments()
        .then((d) => {
          const ts = d.tournaments || [];
          const live = ts.filter((t) => t.status === 'live');
          const source = live.length ? live : ts.filter((t) => t.status === 'upcoming');
          setNames(source.map((t) => t.title).filter(Boolean));
        })
        .catch(() => {});
    };
    load();
    const i = setInterval(load, 60000);
    return () => clearInterval(i);
  }, []);

  if (!names.length) return null;

  const items = [...names, ...names, ...names, ...names];

  return (
    <div className="bg-[#e8173a] overflow-hidden py-2.5 relative z-10" data-testid="live-ticker">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {items.map((name, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="text-white text-xs sm:text-sm font-extrabold uppercase tracking-[0.2em] px-6 whitespace-nowrap">
                  {name}
                </span>
                <Swords className="w-4 h-4 text-white/70 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
